import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import LoadingGlobal from '../../components/LoadingGlobal/LoadingGlobal';
import { setLoading, setLoggingOut } from '../../globalSlice';

const Logout: React.FC<any> = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setLoading(false));
    dispatch(setLoggingOut(false));
    history.replace('/');
  }, [dispatch, history]);

  return <LoadingGlobal/>;
}

export default Logout;
